var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMove = function SvgMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.15149L15.7993 5.95075L14.9507 6.79928L12.6 4.44855V9.00002H11.4V4.44855L9.04927 6.79928L8.20074 5.95075L12 2.15149ZM4.44854 12.6L6.79927 14.9507L5.95074 15.7993L2.15149 12L5.95074 8.20075L6.79927 9.04927L4.44854 11.4H9V12.6H4.44854ZM19.5515 11.4L17.2007 9.04927L18.0493 8.20075L21.8485 12L18.0493 15.7993L17.2007 14.9507L19.5515 12.6H15V11.4H19.5515ZM12.6 15V19.5515L14.9507 17.2007L15.7993 18.0493L12 21.8485L8.20074 18.0493L9.04927 17.2007L11.4 19.5515V15H12.6Z"
  })));
};
export default SvgMove;